<template>
  <section>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(verify_names)">
        <div class="modal-card" style="width: auto" id="modal-event">
          <header class="modal-card-head">
            <p class="modal-card-title">{{modalHeader}}</p>
            <button
                type="button"
                class="delete"
                @click="$emit('close')"/>
          </header>
          <section class="modal-card-body">
            <div class="mb-2" v-if="Object.keys(errores_validacion).length != 0">
              <b-message type="is-danger" has-icon>
                <div v-for="(item,index) in errores_validacion" :key='index'>
                  {{ item[0] }}
                </div>
              </b-message>
            </div>
            <div class="columns">
              <div class="column is-4 is-offset-8">
                <b-switch v-model="requiredFieldOnly">Mostrar todos los campos del formulario</b-switch>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field :label="getNameRequired('CORTO') ? 'Nombre Corto*' :'Nombre Corto'">
                  <ValidationProvider :rules="!getNameRequired('CORTO') ? '' :'required'" v-slot="{ errors }">
                    <b-input type="text" maxlength="255"
                             placeholder="Ej: USACH"
                             :value="entityName!==undefined ? entityName : ''"
                             v-model="entityName"
                             :has-counter=false>
                    </b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div class="column">
                <b-field :label="getNameRequired('COMPLETO') ? 'Nombre Completo*' :'Nombre Completo'">
                  <ValidationProvider :rules="!getNameRequired('COMPLETO') ? '' :'required'" v-slot="{ errors }">
                    <b-input type="text" maxlength="255"
                             placeholder="Ej: Universidad de Santiago de Chile"
                             :value="entityFullName!==undefined ? entityFullName : ''"
                             v-model="entityFullName"
                             :has-counter=false>
                    </b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div v-if="requiredFieldOnly" class="column is-3">
                <b-field label="Rut">
                  <b-input placeholder="ej: 12345678" type="number" min="0" :value="entityRut" v-model="entityRut"></b-input>
                </b-field>
              </div>
              <div v-if="requiredFieldOnly" class="column is-1">
                <b-field label="DV">
                  <b-input placeholder="k" type="text" maxlength="1" :value="entityDv" v-model="entityDv"></b-input>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div v-if="requiredFieldOnly" class="column">
                <b-field label="Descripción">
                  <ValidationProvider v-slot="{ errors }">
                    <b-input type="textarea" maxlength="4000"
                             placeholder="Ingrese la descripción de la entidad"
                             :value="entityDescription!==undefined ? entityDescription : ''"
                             v-model="entityDescription">
                    </b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div v-if="requiredFieldOnly" class="column">
                <b-field label="Email">
                  <ValidationProvider rules="email" v-slot="{ errors }">
                    <b-input  type="text"
                              maxlength="255"
                              placeholder="Ingrese el email de la entidad"
                              :value="entityEmail!==undefined ? entityEmail : ''"
                              v-model="entityEmail"
                              :has-counter=false>
                    </b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div v-if="requiredFieldOnly" class="column">
                <b-field label="Teléfono">
                  <ValidationProvider rules="integer|positive" v-slot="{ errors }">
                    <b-input
                        placeholder="Ej: 221234567"
                        :value="entityPhone!==undefined ? entityPhone : null"
                        v-model="entityPhone">
                    </b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div v-if="requiredFieldOnly" class="column">
                <b-field label="Dirección">
                  <ValidationProvider v-slot="{errors}">
                    <b-input type="text"
                             maxlength="255"
                             placeholder="Ej: Calle 123"
                             :value="entityDirection!==undefined ? entityDirection : ''"
                             v-model="entityDirection"
                             :has-counter=false>
                    </b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div v-if="requiredFieldOnly" class="column">
                <b-field label="Ciudad">
                  <ValidationProvider v-slot="{errors}">
                    <b-input type="text"
                             maxlength="255"
                             placeholder="Ej: Santiago"
                             :value="entityCity!==undefined ? entityCity : ''"
                             v-model="entityCity"
                             :has-counter=false>
                    </b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div class="column">
                <b-field label="País*">
                  <ValidationProvider rules="required" v-slot="{errors}">
                    <b-autocomplete
                        :value="entityNationality!==undefined ? entityNationality : ''"
                        v-model="entityNationality"
                        placeholder="Ej: Chile"
                        :keep-first="keepFirst"
                        :open-on-focus="openOnFocus"
                        :data="filteredDataObjNationality"
                        field="name"
                        @select="option => (selected = option)"
                        :clearable="clearable">
                    </b-autocomplete>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
            </div>
            <div class="columns" v-if="isVisibleByNationality">
              <div class="column">
                <b-field label="Región" >
                  <ValidationProvider v-slot="{errors}">
                    <b-autocomplete
                        :value="entityRegion!==undefined ? entityRegion : ''"
                        v-model="entityRegion"
                        placeholder="Ej: Metropolitana"
                        :keep-first="keepFirst"
                        :open-on-focus="openOnFocus"
                        :data="filteredDataObjRegion"
                        field="name"
                        @input="loadCommunes(getRegionIdByRegionName(entityRegion))"
                        @select="option => (selected = option)"
                        :clearable="clearable">
                    </b-autocomplete>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Comuna">
                  <ValidationProvider v-slot="{errors}">
                    <b-autocomplete
                        :value="entityCommune!==undefined ? entityCommune : ''"
                        v-model="entityCommune"
                        placeholder="Ej: Providencia"
                        :keep-first="keepFirst"
                        :open-on-focus="openOnFocus"
                        :data="filteredDataObjComune"
                        field="name"
                        @select="option => (selected = option)"
                        :clearable="clearable">
                    </b-autocomplete>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div v-if="requiredFieldOnly" class="column">
                <b-field label="Rubro económico">
                  <b-autocomplete
                      :value="entityEconomicActivity!==undefined ? entityEconomicActivity : ''"
                      v-model="entityEconomicActivity"
                      placeholder="Ej: Cultivo de maíz"
                      :keep-first="keepFirst"
                      :open-on-focus="openOnFocus"
                      :data="filteredDataObj"
                      field="name"
                      @select="option => (selected = option)"
                      :clearable="clearable">
                  </b-autocomplete>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div v-if="requiredFieldOnly" class="column">
                <b-field label="Código postal">
                  <ValidationProvider rules="max:9" v-slot="{ errors }">
                    <b-input
                        placeholder="Ej: 8320000"
                        maxlength="9"
                        :has-counter=false
                        :value="entityPostalCode!==undefined ? entityPostalCode : null"
                        v-model="entityPostalCode">
                    </b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div class="column">
                <b-field v-if="requiredFieldOnly" label="Link">
                  <ValidationProvider v-slot="{ errors }">
                    <b-input
                        placeholder="Ej: https://link.com"
                        maxlength="255"
                        :has-counter=false
                        v-model="entityLink">
                    </b-input>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-field label="Tipo de entidad*">
                  <ValidationProvider rules="required" v-slot="{errors}">
                    <multiselect
                        v-model="entityType"
                        :options="entity_types_data.map(type => type.id)"
                        :custom-label="opt => entity_types_data.find(x => x.id === opt).name"
                        placeholder="Ej: Universidad"
                        selectLabel="Presione para seleccionar"
                        selectedLabel="Seleccionado"
                        deselectLabel=""
                        :allow-empty="false">
                    </multiselect>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div class="column">
                <b-field label="¿Es entidad pública?">
                  <div class="columns">
                    <div class="column">
                      <b-radio-button v-model="entityIsPublic"
                                      :native-value="false"
                                      type="is-danger is-light is-outlined"

                      >
                        <b-icon icon="times-circle"></b-icon>
                        <span>No</span>
                      </b-radio-button>
                    </div>
                    <div class="column">
                      <b-radio-button v-model="entityIsPublic"
                                      :native-value="true"
                                      type="is-success is-light is-outlined"
                      >
                        <b-icon icon="check-circle"></b-icon>
                        <span>Si</span>
                      </b-radio-button>
                    </div>
                  </div>

                </b-field>
              </div>
            </div>

            <div v-if="requiredFieldOnly" class="columns">
              <div class="column">
                <b-field label="¿Es Sub Entidad?">
                  <div class="columns">
                    <div class="column">
                      <b-radio-button v-model="sub_entity"
                                      :native-value="false"
                                      type="is-danger is-light is-outlined"

                      >
                        <b-icon icon="times-circle"></b-icon>
                        <span>No</span>
                      </b-radio-button>
                    </div>
                    <div class="column">
                      <b-radio-button v-model="sub_entity"
                                      :native-value="true"
                                      type="is-success is-light is-outlined"
                      >
                        <b-icon icon="check-circle"></b-icon>
                        <span>Si</span>
                      </b-radio-button>
                    </div>
                  </div>
                </b-field>
              </div>
              <div class="column">
                <b-field v-if="sub_entity">
                  <template #label>
                    Pertenece a la entidad (ingrese por lo menos 3 letras)
                    <b-tooltip
                        label="Se recomienda búsqueda por sigla, ejemplo: ANID, no Agencia Nacional... mientras que para instituciones educacionales, se recomienda por nombre completo, ejemplo: universidad de santiago de chile"
                        position="is-right"
                        size="is-medium"
                        multilined>

                      <b-icon
                          pack="fas"
                          icon="info-circle"
                          size="is-small"
                          type="is-info">
                      </b-icon>
                    </b-tooltip>
                  </template>
                  <ValidationProvider :rules="sub_entity ? 'required':''" v-slot="{ validate, errors }">
                    <b-autocomplete
                        @input="validate"
                        :data="partner_entities"
                        placeholder="ej ANID o UNIVERSIDAD DE SANTIAGO DE CHILE  o NOMBRE EMPRESA - ENTIDAD"
                        field="show_name"
                        :loading="isFetching"
                        @typing="searchPartnerEntities"
                        @select="option => {if (option) {partner_entity.id = option.id} }"
                        v-model="partner_entity.name">
                      <template slot-scope="props">
                        {{ props.option.show_name ? props.option.show_name : props.option.name}}
                      </template>
                    </b-autocomplete>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>

                </b-field>
              </div>
            </div>
          </section>
        </div>
        <footer class="modal-card-foot actions">
          <div class="field is-grouped is-pulled-lefts">
            <button class="button" type="button" @click="$emit('close')">Cerrar</button>
            <button class="button is-primary" type="submit" :disabled="isDisabled">Agregar</button>
          </div>
        </footer>
      </form>
    </ValidationObserver>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
  </section>
</template>
<script>
import axios from 'axios'
export default {
  name: 'modal_partner_entity_life_record',
  props:[
    'queryType', 'personId', 'id','modalHeader', 'allEntityTypes'],
  data(){
    return {
      errores_validacion: {},
      // variables controladoras
      isLoading:true,
      isFullPage: true,
      isSubmiting: false,
      keepFirst: false,
      openOnFocus: false,
      selected: null,
      clearable: false,
      isDisabled: false,

      // Para almacenamiento temporal
      nationalities_data: [],
      regions_data: [],
      communes_data: [],
      economic_activities_data: [],
      entity_types_data: [],
      nationality_name: '',
      region_name: '',
      commune_name: '',
      economic_activity_name: '',
      entity_type_name: '',
      entityPostalCode: '',
      entityLink: '',
      entityFullName: "",
      // para el envío de datos
      entityInfo:{
        name: '',
        full_name:'',
        description: '',
        email: '',
        phone: null,
        established: null,
        direction: '',
        city: '',
        is_public: false,
        nationality_id: null,
        region_id: null,
        commune_id: null,
        economic_activity_id: null,
        entity_type_id: null,
        url: null,
        postal_code: null,
        run_attributes:{
          rut: null,
          dv: null
        }
      },
      requiredFieldOnly: false,
      sub_entity: false,
      partner_entities:[],
      partner_entity:{},
    }
  },
  computed:{
    // Filtros y visibilidad
    filteredDataObj() {
      return this.economic_activities_data.filter(option => option.name.toLowerCase().includes(this.economic_activity_name.toLowerCase()))
    },
    filteredDataObjComune() {
      return this.communes_data.filter(option => option.name.toLowerCase().includes(this.commune_name.toLowerCase()))
    },
    filteredDataObjRegion() {
      return this.regions_data.filter(option => option.name.toLowerCase().includes(this.region_name.toLowerCase()))
    },
    filteredDataObjNationality() {
      return this.nationalities_data.filter(option => option.name.toLowerCase().includes(this.nationality_name.toLowerCase()))
    },
    isVisibleByNationality(){
      return this.nationality_name.toUpperCase() === 'CHILE'
    },

    // Para el control de los atributos
    entityName:{
      get: function(){
        return this.entityInfo.name
      },
      set: function(newName){
        this.entityInfo.name = newName.toUpperCase()
      }
    },
    entityRut:{
      get: function(){
        return this.entityInfo.run_attributes.rut
      },
      set: function(newRut){
        this.entityInfo.run_attributes.rut = newRut
      }
    },
    entityDv:{
      get: function(){
        return this.entityInfo.run_attributes.dv
      },
      set: function(newDv){
        this.entityInfo.run_attributes.dv = newDv
      }
    },
    entityDescription:{
      get: function(){
        return this.entityInfo.description
      },
      set: function(newDescription){
        this.entityInfo.description = newDescription
      }
    },
    entityEmail:{
      get: function(){
        return this.entityInfo.email
      },
      set: function(newEmail){
        this.entityInfo.email = newEmail
      }
    },
    entityPhone:{
      get: function(){
        return this.entityInfo.phone
      },
      set: function(newPhone){
        this.entityInfo.phone = parseInt(newPhone, 10)
      }
    },
    entityDirection:{
      get: function(){
        return this.entityInfo.direction
      },
      set: function(newDirection){
        this.entityInfo.direction = newDirection
      }
    },
    entityCity:{
      get: function(){
        return this.entityInfo.city
      },
      set: function(newCity){
        this.entityInfo.city = newCity
      }
    },
    entityNationality:{
      get: function(){
        return this.nationality_name
      },
      set: function(newNationality){
        if(newNationality.toUpperCase() !== 'CHILE'){
          this.region_name = ""
          this.commune_name = ""
          this.economic_activity_name = ""
        }
        this.nationality_name = newNationality
      }
    },
    entityRegion:{
      get: function(){
        return this.region_name
      },
      set: function(newRegion){
        this.region_name = newRegion
      }
    },
    entityCommune:{
      get: function(){
        return this.commune_name
      },
      set: function(newCommune){
        this.commune_name = newCommune
      }
    },
    entityEconomicActivity:{
      get: function(){
        return this.economic_activity_name
      },
      set: function(newEconomicActivity){
        this.economic_activity_name = newEconomicActivity
      }
    },
    entityType:{
      get: function(){
        return this.entity_type_name
      },
      set: function(newEntityType){
        this.entity_type_name = newEntityType
      }
    },
    entityIsPublic:{
      get: function(){
        return this.entityInfo.is_public
      },
      set: function(newEntityIsPublic){
        this.entityInfo.is_public = newEntityIsPublic
      }
    },

    // Validaciones en los campos del formulario
    checkSubmiting: {
      get: function(){
        return this.isSubmiting
      },
      set: function(newState){
        this.isSubmiting = newState
      }
    }
  },
  beforeMount(){
    // Se ejecutarán antes de renderizar la página
    this.getNationalities()
    this.getRegions()
    //this.getCommunes()
    this.getEconomicActivities()
    this.getEntityTypes()

  },
  methods:{
    //verificacion de nombres
    verify_names(){
      this.isLoading= true;
      axios
          .get("/partner_entities/find_name_coincidence.json", {
            params: {name: this.entityName, full_name: this.entityFullName,
              id: this.entity_id, queryType: "create"}
          })
          .then(response =>{
            this.save_entity()
          }).catch(error => {
        if(error.response.status === 409){ //se encuentra
          this.isLoading = false
          this.$buefy.dialog.confirm({
            hasIcon: true,
            type: "is-warning",
            title: "Advertencia",
            message: error.response.data["message"],
            confirmText: "Continuar y guardar",
            cancelText: "Cancelar",
            onConfirm: () => this.save_entity(),
            onCancel: () => this.isLoading = false
          })
        }
        else if(error.response.status === 400){//bad request
          this.errores_validacion = error.response.data
          var elmnt = document.getElementById("app");
          elmnt.scrollIntoView();
          this.$refs.modalPersonForm.scrollTop = 0;
          this.$buefy.dialog.alert({
            title: 'Error',
            message: 'Hubo errores al agregar la entidad, favor revisar formato',
            type: 'is-danger',
            hasIcon: true,
            icon: 'times-circle',
            iconPack: 'fa',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          this.isLoading=false;
        }
      })
    },
    getNameRequired(type){
      let retorno = true;
      if(type=="CORTO"){
        if(this.entityFullName.length>0){
          retorno = false;
        }
      }
      if(type=="COMPLETO"){
        if(this.entityName.length>0){
          retorno = false;
        }
      }
      if(this.entityFullName.length>0 && this.entityName.length>0){
        retorno = true;
      }
      return retorno;
    },
    // Consultas al backend
    getEntity(){
      axios.get('/partner_entities/show/'+this.entity_id+'.json')
          .then( response =>{
            this.entityName = response.data.entity.alt_name ? response.data.entity.alt_name : response.data.entity.name;
            this.entityFullName = response.data.entity.alt_full_name ? response.data.entity.alt_full_name : response.data.entity.full_name;
            this.entityDescription = response.data.entity.description
            this.entityEmail = response.data.entity.email
            this.entityPhone = response.data.entity.phone
            this.entityDirection = response.data.entity.direction
            this.entityCity = response.data.entity.city
            this.entityNationality = response.data.entity.entity_nationality
            this.entityRegion = response.data.entity.entity_region
            this.entityCommune = response.data.entity.entity_commune
            this.entityEconomicActivity = response.data.entity.entity_economic_activity
            this.entityType = response.data.entity.entity_type
            this.entityIsPublic = response.data.entity.is_public
            this.entityRut = (response.data.entity.rut == null) ? null : response.data.entity.rut.rut
            this.entityDv = (response.data.entity.rut == null) ? null : response.data.entity.rut.dv
            if (this.entityRegion != null)
            {
              this.loadCommunes(this.getRegionIdByRegionName(this.entityRegion))
            }
            if (response.data.entity.entity_mayor != null){
              this.searchPartnerEntities(response.data.entity.entity_mayor.name)
              this.partner_entity = response.data.entity.entity_mayor
              this.sub_entity = true
              this.isLoading=false
            }
            else{
              this.sub_entity = false
              this.isLoading=false
            }
            this.isLoading=false
          })
          .catch(e =>{
            console.log(e)
            this.isLoading=false
          })
    },
    getNationalities(){
      axios.get('/nationalities.json')
          .then( response =>{
            this.nationalities_data = response.data
          })
          .catch(e => {
            console.log(e)
          })
    },
    getRegions(){
      axios.get("/admin/regions.json")
          .then(response =>{
            this.regions_data = response.data
          })
          .catch(e =>{
            console.log(e)
          })
    },
    /*getCommunes(){
        axios.get("/admin/communes.json")
        .then(response =>{
            this.communes_data = response.data
        })
        .catch(e =>{
            console.log(e)
        })
    },*/
    getEconomicActivities(){
      axios.get("/economic_activities.json")
          .then(response =>{
            this.economic_activities_data = response.data
          })
          .catch(e =>{
            console.log(e)
          })
    },
    getEntityTypes(){
      let url = "/admin/entity_types.json"
      axios.get(url)
          .then(response =>{
            this.entity_types_data = response.data
            this.isLoading=false
          })
          .catch(e =>{
            console.log(e)
            this.isLoading=false
          })
    },
    // FUnciones transformadoras de Nombre a Id y viceversa
    getNationalityIdByNationalityName(nationality_name){
      var id = null
      this.nationalities_data.forEach(function(element){
        if (element.name === nationality_name){
          id = element.id
        }
      })
      return id
    },
    getRegionIdByRegionName(region_name){
      var id = null
      this.regions_data.forEach(function(element){
        if (element.name === region_name){
          id = element.id
        }
      })
      return id
    },
    getCommuneIdByCommuneName(commune_name){
      var id = null
      this.communes_data.forEach(function(element){
        if (element.name === commune_name){
          id = element.id
        }
      })
      return id
    },
    getEconomicActvityIdByEconomicActivityName(economic_activity_name){
      var id = null
      this.economic_activities_data.forEach(function(element){
        if (element.name === economic_activity_name){
          id = element.id
        }
      })
      return id
    },
    getEntityTypeIdByEntityTypeName(entity_type_name){
      var id = 1
      this.entity_types_data.forEach(function(element){
        if (element.name === entity_type_name){
          id = element.id
        }
      })
      return id
    },
    back(){
      this.isLoading=true
      window.location.href="/partner_entities/index"
    },
    // Envío de datos al backend
    async save_entity(){
      this.isLoading=true
      this.checkSubmiting = true
      const isValid = await this.$refs.observer.validate();
      if (!isValid){
        this.checkSubmiting = false
        return this.$buefy.dialog.alert({
          title: 'Error',
          message: 'Se encontraron errores, revisar formato y datos requeridos en formulario',
          type: 'is-danger',
          hasIcon: true,
          icon: 'times-circle',
          iconPack: 'fa',
          ariaRole: 'alertdialog',
          ariaModal: true
        })

      }
      this.entityInfo.nationality_id = this.getNationalityIdByNationalityName(this.nationality_name)
      if(this.nationality_name.toUpperCase() === 'CHILE'){
        this.entityInfo.region_id = this.getRegionIdByRegionName(this.region_name)
        this.entityInfo.commune_id = this.getCommuneIdByCommuneName(this.commune_name)
        this.entityInfo.economic_activity_id = this.getEconomicActvityIdByEconomicActivityName(this.economic_activity_name)
      }
      else{
        this.entityInfo.region_id = null
        this.entityInfo.commune_id = null
        this.entityInfo.economic_activity_id = null
      }

      if(this.entityInfo.run_attributes.rut == ""  || this.entityInfo.run_attributes.dv == "")
      {
        this.entityInfo.run_attributes.rut = null
        this.entityInfo.run_attributes.dv = null
      }

      this.entityInfo.entity_type_id = this.entity_type_name
      this.entityInfo.full_name = this.entityFullName;

      this.entityInfo.skip_if_import = true

      if(this.partner_entity.name != null){
        if(this.partner_entity.name.length > 0){
          this.entityInfo.partner_entity_id = this.partner_entity.id
        }
        else{
          this.entityInfo.partner_entity_id = null
        }
      }
      else{
        this.entityInfo.partner_entity_id = null
      }

      axios.post('/admin/partner_entities.json', this.entityInfo)
          .then( response =>{
            this.errores_validacion = {};
            this.$buefy.dialog.alert({
              title: "Entidad creada con éxito",
              message: "La entidad ha sido creada sin ningún problema.",
              onConfirm: () => {
                this.checkSubmiting = false
                this.isLoading=false
                this.$emit('clicked',response.data)
                this.$emit('close')
              }
            })
          })
          .catch(e => {
            this.checkSubmiting = false
            this.errores_validacion = e.response.data;
            //this.checkEmptyFields()
            this.$buefy.dialog.alert({
              title: "Error en la creación de la entidad.",
              message: "Faltan campos por rellenar o tienen errores.",
              type: 'is-danger',
              hasIcon: true,
              onConfirm: () => {
                this.checkSubmiting = false
                this.isLoading=false
              }
            })
            this.isLoading=false
          })


    },
    loadCommunes(region_id){
      if( region_id!==null && region_id!==undefined && region_id!==""){
        this.isLoading=true;
        axios
            .get("/regions/"+region_id+"/communes.json")
            .then(res => {
              this.communes_data = res.data["communes"];
              this.isLoading = false;
            })
            .catch(error => {
              console.log(error)
              this.isLoading=false;
            })
      }
      else{
        this.communes = []
      }
    },
    searchPartnerEntities(name){
      if (name.length<3) {
        this.partner_entities = [];
        return
      }
      let vm = this;
      vm.isLoading = true;
      axios
          .get("/admin/partner_entities/financings-search.json", { params: { name: name } })
          .then(res => {
            vm.partner_entities = res.data;
            vm.isLoading = false;
          })
          .catch(error => {
            console.log(error)
            vm.isLoading = false;
          })

    },
  },
  watch:{
    sub_entity: function(){
      if (this.sub_entity == false){
        this.partner_entity = {}
      }
    }
  }

  // Instrucciones para hacer a rubro económico obligatorio
  /*
  1.- Pegar estas lineas al lado de la etiqueta b-field:
      :type="{ 'is-danger': checkEntityEconomicActivity }"
      :message="{ 'Seleccione un rubro económico.': checkEntityEconomicActivity }"

  2.- Descomentar las líneas (1) y (2)
  */
}
</script>